import type { FaireProductEntity } from "../../entity_types/product";

export const p_27bjtjf6pn: FaireProductEntity = {
  token: "p_27bjtjf6pn",
  type: "product",
  name: "Lemon Lavender Love your Locks Wet & Dry Scalp Massager",
  brandToken: "b_5o8ey581fk",
  brandName: "DM Merchandising",
  imageUrl:
    "https://cdn.faire.com/fastly/f8bfc69359d6ed4113275c38c592f2fde8a5f31d8413b901d31297494b815f49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b598df388806d20e39b0df858ffbae0bd518021c8f61d371b4134bef13e7e6f3.jpeg",
    "https://cdn.faire.com/fastly/5c6cc8db81ca25137b0a32964d3a4a4cdda18b75b023c567e1eb28e679009a29.jpeg",
    "https://cdn.faire.com/fastly/88cc23e8a34644faeb5546abddb8f2aaad1efe2b1065feadb3e00da71a03284e.jpeg",
    "https://cdn.faire.com/fastly/3f50b6299e019a74c6e9649000826bf287df5b95927fa57d406455cc23646435.jpeg",
    "https://cdn.faire.com/fastly/be8a5a7ef2c59527092f7b42a5b3e4a3a26dc5d33023dfe913e758c8991c24a1.jpeg",
    "https://cdn.faire.com/fastly/0f23092f16e6519bcc348525e03cf6035dcb4ab8418eb0e6b3bdb77606f52279.jpeg",
    "https://cdn.faire.com/fastly/6553bc6033135f893aeb1cc216039740a83936ed3b4058d5b4655458aa177f8b.jpeg",
    "https://cdn.faire.com/fastly/4eee401bec03ac125dfb98ec7ce7c2cc20f9607907f4f14e9563f0b0ecd4ba72.jpeg",
  ],
  priceDollars: 2.25,
  description:
    "Keep your scalp clean and your hair happy! Erase tension, deep clean roots and wash stress down the drain with a spa-quality massage in the comfort of your own shower. Flexible silicone bristles gently remove build-up, stimulate hair growth and distribute your hair’s natural oils for salon-worthy hair care in the palm of your hand. Includes handy hanging loop.\n\n-Wide-tooth design for all hair types\n-Use on its own or in the shower\n-Erase tension & deep clean roots\n-Three colors: Pink, Purple & Blue \n-Ships in free counter display\n-Boxed & peggable\n-Includes hanging loop",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:22.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
